import * as React from "react";
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import { TypeaheadEnterEscWrapper } from "../app/components/TypeaheadEnterEscWrapper";

export interface NestedOption
{
    level: number;
    option: any;
}

interface Props
{
    selected: NestedOption;
    options: NestedOption[];
    labelKey?: (option: any) => string;
    onChange: (option: any) => void;
    className?: string;
}

interface State
{
    textInput: string;
}

// NestedTypeahead is a wrapper around 3d party react-bootstrap-typeahead component
// The are 2 important additions:
// * It allows to display nested data via indentation to reflect hierarchical structure of the data
// * It stops Enter and Esc keyDown propagation when menu is opened
export class NestedTypeahead extends React.Component<Props, State>
{
    private id = (option: any) => option;
    
    constructor(props: Props)
    {
        super(props);
        this.state = {
            textInput: ''
        };
    }

    render()
    {
        const { options, selected, labelKey, onChange, ...rest } = this.props;
        const { textInput } = this.state;

        const label = labelKey || this.id;

        return (
            <TypeaheadEnterEscWrapper>
                <Typeahead labelKey={nestedOption => label(nestedOption.option)}
                    className={this.props.className}
                    options={options} selected={selected ? [selected] : []}
                    onChange={(option) => onChange(option)}
                    onInputChange={text => this.setState({ textInput: text })}
                    renderMenu={(textInput != null && textInput !== '') ? null :
                        (results: any[], menuProps) => (
                            <Menu {...menuProps}>
                                {
                                    results.map((item, idx) => (
                                        <MenuItem key={idx} option={item} position={idx}>
                                            <span style={{marginLeft: item.level * 10}}>{label(item.option)}</span>                                    
                                        </MenuItem>
                                    ))
                                }
                            </Menu>
                        )
                    }
                    {...rest}
                />
            </TypeaheadEnterEscWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NestedTypeahead.tsx